import React from 'react';
import { Icon } from 'semantic-ui-react';
import './style.css';

const CustomRadioButtonV1 = (props) => {
  return (
    <div className="customRadioButton-v1">
      <input type="radio" checked={props.checked} onChange={function() {}} />
      <Icon name="check" />
    </div>
  );
}

export default CustomRadioButtonV1;